import React from 'react';

// Shown at the top of both dashboard pages once a user has at least one
// listing (past or present) — lets them flip between their buyer ("Staying")
// and owner ("Hosting") views without navigating away.
export default function DashboardRoleToggle({ view, onChange }) {
  return (
    <div className="container" style={{ maxWidth: 960, paddingTop: '1.5rem' }}>
      <div className="pill-tabs" style={{ marginBottom: 0 }}>
        <button type="button" className={`pill-tab-btn ${view === 'staying' ? 'active' : ''}`} onClick={() => onChange('staying')}>
          Staying
        </button>
        <button type="button" className={`pill-tab-btn ${view === 'hosting' ? 'active' : ''}`} onClick={() => onChange('hosting')}>
          Hosting
        </button>
      </div>
    </div>
  );
}
